export class FeatureFlag {
    static isEnabled() {
        return '1' === sessionStorage.getItem('ampFeatureFlag');
    }

    static isGaEnabled() {
        return 1 === $('#dataGa').data('gaflag');
    }
}
